var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.4,
    height: 99.986,
    viewBox: "0 0 125.4 99.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14973",
    "data-name": "Grupo 14973",
    transform: "translate(0.328 -668.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72053",
    "data-name": "Trazado 72053",
    d: "M-24345.385,3768a179.441,179.441,0,0,0-15.361-26.538,193.075,193.075,0,0,0-31.506-34.509c-19-16.207-46.338-34.273-77.945-37.793",
    transform: "translate(24470 -3000)",
    fill: "none",
    stroke: "#1071bc",
    strokeWidt: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72054",
    "data-name": "Trazado 72054",
    d: "M-24369.055,3768.312s-15.719-17.246-34.139-29.043c-32.631-21.833-59.941-23.44-67.088-22.757",
    transform: "translate(24470 -3000)",
    fill: "none",
    stroke: "#1071bc",
    strokeWidt: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.8d791d78c05ab248dc70aae0952a9b53.svg";
export { ForwardRef as ReactComponent };